import Cookies from "universal-cookie"

import dayjs from "dayjs"
import config from "../config"
import getCompleteApiUrl from "../getCompleteApiUrl"
import {Operation} from "../../classes/Operation"
import {ApiCallFailure} from "../../classes/exception/ApiCallFailure";

export default async function getOngoingOperations() {
    const cookies = new Cookies()

    if (cookies.get("accessToken") === undefined) {
        const error = new ApiCallFailure()
        error.connectionSuccessful = false
        error.errorType = "NO_ACCESS_TOKEN"

        throw error
    }

    const currentTime = dayjs()

    var res: Response
    try {
        res = await fetch(getCompleteApiUrl(config, `/operations?timeStartBefore=${encodeURIComponent(currentTime.format())}&timeEndAfter=${encodeURIComponent(currentTime.format())}`), {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${cookies.get("accessToken")}`
            }
        })
    } catch (error) {
        const apiFailure = new ApiCallFailure()
        apiFailure.connectionSuccessful = false

        throw apiFailure
    }

    if (res!.status === 200) {
        const responseObject = await res!.json()

        return responseObject.map((obj: object) => {
            const responseOperation = new Operation()
            responseOperation.parseObject(obj)
            return responseOperation
        })
    }

    const callFailure = new ApiCallFailure()
    callFailure.connectionSuccessful = true
    callFailure.responseCode = res!.status
    callFailure.errorType = "REQUEST_REJECTED"

    throw callFailure
}